import { computed } from '@angular/core';
import {
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
} from '@ngrx/signals';
import { ColorsetState } from './colorset.state';
import { StateFilter } from '../crud.state';
import { Colorset } from '../../models/colorset';

export const filterItems = (items: Colorset[], filter: StateFilter) => {
  return items.filter(item => {
    const titleMatch = item.name
      .toLowerCase()
      .includes(filter.query.toLowerCase());
    return titleMatch;
  });
};

export function withColorsetSelectors() {
  return signalStoreFeature(
    {
      state: type<ColorsetState>(),
    },
    withComputed(({ items }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => Object.values(items())),
      allColors: computed(() => [
        ...new Set(Object.values(items()).flatMap(set => set.colors)),
      ]),
    })),
    withMethods(store => ({
      getFirstByIds(ids: string[]): null | Colorset {
        for (const id of ids.filter(id => !!id)) {
          const colorset = store.items()[id];

          if (colorset) {
            return colorset;
          }
        }
        return null;
      },
      globalSearch(query: string): Colorset[] {
        const itemsArray = Object.values(store.items());
        const tempFilter: StateFilter = { ...store.filter(), query };
        return filterItems(itemsArray, tempFilter);
      },
    }))
  );
}
